// Development: localhost
// Production: https://api.constatatoare.ro
export const API_URL = 'https://api.constatatoare.ro';
